import { useQuery } from '@tanstack/react-query'
import {
  fetchSubInterfaces,
  subsQueryKey,
  SubInterface,
} from './resolveSourceInterfaceIds'

/**
 * True when the interface is a control hub — i.e. it has sub-controllers.
 *
 * This is a property of the interface, not of any single decoder tab, so it
 * comes from the sub-controllers endpoint rather than from whatever rows a tab
 * happens to have loaded (a plain controller returns none).
 *
 * Shares the `subs` cache entry with `resolveSourceInterfaceIds`, so the list
 * is fetched once for the page rather than once per consuming hook.
 */
function useIsControlHub(interfaceId: number) {
  return useQuery<SubInterface[], any, boolean>(
    subsQueryKey(interfaceId),
    () => fetchSubInterfaces(interfaceId),
    {
      enabled: interfaceId > 0,
      staleTime: 5 * 60 * 1000,
      placeholderData: [],
      select: (subs) => Array.isArray(subs) && subs.length > 0,
    },
  )
}

export default useIsControlHub
